import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { EventService, IJobScreenEvent, JobsService, TaskService } from '../../../../services';
import {
  JobScreenTaskDetails,
  JobScreenTasksJob,
  JobScreenTasksTask,
} from '../../../../interfaces/screen-specific/job-screen';
import { SelectItem } from 'primeng';
import { Subscription } from 'rxjs';

@Component({
  selector: 'job-screen-tasks',
  templateUrl: './job-screen-tasks.component.html',
  styleUrls: ['./job-screen-tasks.component.scss', '../job-screen-common.scss'],
})
export class JobScreenTasksComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input('jobId') jobId!: number;
  @Input('orderId') orderId!: number;
  @Input('organisationId') organisationId!: number;
  @Input('organisationTypeId') organisationTypeId!: number;

  tasks: JobScreenTasksTask[] = [];
  job: JobScreenTasksJob;
  actualTaskTypeId: number;
  taskTypeId: number;
  taskDetails: JobScreenTaskDetails[];
  selectedTask: JobScreenTaskDetails;

  subscriptions: Subscription[] = [];

  public taskTypes: SelectItem[] = [];
  activeIndex: number = 0;
  selectedTaskId: number;

  constructor(
    private jobService: JobsService,
    private eventService: EventService,
    private taskService: TaskService,
  ) {}

  async ngOnInit() {
    void this.loadJob();
  }

  ngAfterViewInit() {
    this.subscriptions.push(
      this.eventService.JobScreenEvent.subscribe((event: any) => {
        this.processEvents(event);
      }),
    );
  }

  private processEvents(event: IJobScreenEvent) {
    if (event.event == 'task-changed') {
      this.selectedTaskId = event.data.taskId;
      this.selectedTask = this.taskDetails?.find(
        (taskDetails) => taskDetails.id == event.data.taskId,
      );
    }
    if (event.event == 'refresh-supplier') {
      void this.loadJob();
    }
    if (event.event == 'sequence-update') {
      void this.loadJob();
    }
    if (event.event == 'refresh-task-details') {
      void this.getTaskDetails();
    }
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.orderId.currentValue) {
      if (this.job) {
        this.tasks = this.job.orders.find((x) => x.id == this.orderId)?.tasks;
        this.selectedTaskId = this.tasks[0]?.id;

        void this.getTaskDetails();
      }
    }
  }

  async loadJob() {
    // Load job
    const jobDetails: JobScreenTasksJob = await this.jobService.getForComponent(
      this.jobId,
      'job-screen-tasks',
    );
    this.job = jobDetails;
    this.tasks = jobDetails?.orders?.find((x) => x.id == this.orderId)?.tasks || [];
    this.selectedTaskId = jobDetails?.orders?.find((x) => x.id == this.orderId)?.tasks[0]?.id;

    await this.getTaskDetails();
  }

  async getTaskDetails() {
    const taskDetails = await this.taskService.getJobScreenTaskDetails(
      this.tasks.map((task) => task.id),
    );
    this.taskDetails = taskDetails;
    this.selectedTask = taskDetails.find((taskDetails) => taskDetails.id == this.selectedTaskId);
  }

  clickedTask(taskId: any) {
    this.selectedTaskId = taskId;
    this.selectedTask = this.taskDetails.find((taskDetails) => taskDetails.id == taskId);
    this.eventService.JobScreenEvent.emit({
      event: 'task-changed',
      data: { taskId: taskId, orderId: this.orderId, jobId: this.jobId },
      sender: 'clickedTask',
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => x?.unsubscribe());
  }
}
